import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../api/axiosInstance";
import { getBanks } from "../../api/bankRequests";
import { useLanguageContext } from "../contexts/LanguageContext";
import ModifiedForm from "../layout/form/ModifiedForm";
import { CheckBox, Combobox, TextField } from "../layout/form/TextInputFields";
import ErrorHandler from "../../error-handler/ErrorHandler";
import { Button } from "react-bootstrap";
const COMPONENT = "Create-Branch: ";

function CreateBranch() {
  const { language } = useLanguageContext();
  const { t } = useTranslation();

  async function submitBranch(data) {
    try {
      const res = await axiosInstance.post("/branches", data);
      console.log(`${COMPONENT} Res: ${JSON.stringify(res)}`);
      return { type: 1, message: t("success") };
    } catch (e) {
      console.error(e);
      return { type: 2, message: e.message };
    }
  }

  const [banks, setBanks] = useState();

  useEffect(() => {
    getBanks().then((it) => {
      setBanks(it);
    });
  }, []);

  return (
    <ModifiedForm submitFunction={submitBranch}>
      <h4 className="title">{t("branch.branch")}</h4>

      <div className="styledform">
        <TextField
          className="formTextField"
          id={"name_ar"}
          validation={{
            required: true,
          }}
          title={t("form.nameAR")}
        />
        <TextField
          className="formTextField"
          id={"name_en"}
          validation={{
            required: true,
          }}
          title={t("form.nameEN")}
        />
        <TextField
          className="formTextField"
          id={"branch_code"}
          validation={{
            required: true,
          }}
          title={t("branch.code")}
        />

        <Combobox
          className="formTextField"
          id={"bank"}
          validation={{
            required: true,
          }}
          title={t("branch.bank")}
        >
          {banks?.map((it) => {
            const value = it[`name_${language}`];
            return (
              <option key={it.id} value={it.id}>
                {value}
              </option>
            );
          })}
        </Combobox>

        <CheckBox
          className="formTextField"
          id={"is_main_branch"}
          title={t("branch.main")}
        />
      </div>

      <div className="formSubmit">
        <button className="defaultButton" type="submit">
          {t("buttons.finish")}
        </button>
      </div>
    </ModifiedForm>
  );
}

export default ErrorHandler(CreateBranch, axiosInstance);
